import { render, staticRenderFns } from "./SimilarAnnotation.vue?vue&type=template&id=40b676b8&scoped=true"
import script from "./SimilarAnnotation.vue?vue&type=script&lang=js"
export * from "./SimilarAnnotation.vue?vue&type=script&lang=js"
import style0 from "./SimilarAnnotation.vue?vue&type=style&index=0&id=40b676b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40b676b8",
  null
  
)

export default component.exports